import React, { useContext } from 'react'
import { useEffect, useState } from 'react'
import axios from 'axios';
import { Link } from 'react-router-dom'
import rewardduplicate from '../../assets/reward-duplicate.png'
import ENDPOINT from '../../data/ENDPOINT';
import Toast from 'react-bootstrap/Toast'
import { AuthContext } from '../../context/AuthContext';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Lock from '@mui/icons-material/Lock';
import Localbase from 'localbase'
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import DoneIcon from '@mui/icons-material/Done';
import RedeemIcon from '@mui/icons-material/Redeem';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
// import '../../assets/css/refer.css'
import '../../assets/css/refer.css'
import ReferralProgram from './ReferralProgram';
import CopyToClipboard from 'react-copy-to-clipboard';
import UnregisteredReferralPage from './UnregisteredReferralPage';


const ScratchCards = () => {

    const [refdata, setrefdata] = useState(null)

    const { user } = useContext(AuthContext)
    const [toast, settoast] = useState(false);
    const GetReferrals = async () => {


        const formData = new FormData();
        formData.append('session', user.SessionId)

        const res = await axios.post(`${ENDPOINT}referral-program.php`, formData, {
            headers: {
                'content-type': 'multipart/form-data'
            }
        })



        if (res) {
            console.log(res.data.data)
            setrefdata(res.data.data)
            if (res.data.status === "success") {
                setrefdata(res.data.data)
            } else {

            }
        }

    }
    useEffect(() => {
        GetReferrals();
    }, [])
    return (
        <Styled>
            <>
                <>


                </>

                {refdata ? <>

                    <div className="container-fluid p-0 p-md-5 col-lg-12">


                        <div className="position-fixed bottom-60 left-0 w-100 justify-center">
                            <Toast className="bg-warning" onClose={() => settoast(false)} show={toast} delay={3000} autohide>
                                <Toast.Header className="bg-warning text-dark">
                                    <img
                                        src="holder.js/20x20?text=%20"
                                        className="rounded bg-warning me-2"
                                        alt=""
                                    />
                                    <strong className="me-auto">Referral code copied</strong>

                                </Toast.Header>
                            </Toast>

                        </div>

                        <div className="d-flex flex-wrap justify-content-between">
                            {/* Online Course Box */}
                            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 p-3">
                                <div className="border card bg-white mt-1 rounded-4 box-shadow hover-scale p-3 hover-purple">
                                    <h2 className="text-center mt-2">Online Course</h2>
                                    <p className="text-center ">Everything you need to learn a new skill from your home</p>
                                    <div className="mt-3">
                                        <div className="d-flex align-items-center">
                                            👨‍💻 <p className="ms-1">Daily online class</p>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            ▶️<p className="ms-1">Daily class recording</p>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            🕖<p className="ms-1">24/7 Mentor support</p>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            💻<p className="ms-1">Premium Notes & Softwares</p>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            👩🏻‍💼<p className="ms-1">Placement trainings</p>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            💯<p className="ms-1">100% Placement assistance</p>
                                        </div>
                                    </div>
                                    {/* <div className="pay mt-3 ps-3">
                                    <div className="d-flex mb-1">
                                        <p className="m-0">They pay</p>
                                        <div className="border border-dark rounded-3 ms-2">-20%</div>
                                    </div>
                                    <div className="d-flex">
                                        <s>₹2,628.00</s>
                                        <p className="ms-1">
                                            <b>₹2,102.40</b>
                                        </p>
                                    </div>
                                </div> */}
                                    <div className="d-flex align-items-center text-success commission pt-2 ps-2 mt-2 rounded">
                                        🎁<p className="ms-1 sm-18 m-0">Your commission</p>
                                        <h5 className="ms-3 sm-16 m-0 mt-2">₹150</h5>
                                    </div>
                                    <div className="d-flex mt-4 mb-2">


                                        <CopyToClipboard onCopy={() => settoast(true)} text={`https://skillsuprise.com/referral=${refdata.referral_code}`}  >

                                            <button className="border rounded bg-white p-2 copyb">📋</button>

                                        </CopyToClipboard>


                                        <button
                                            className="refer-button border ms-2 w-100 text-center rounded pt-2 copyb"
                                            onClick={() => {
                                                const referralUrl = `https://skillsuprise.com/referral=${refdata.referral_code}`;
                                                const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(referralUrl)}`;
                                                window.open(whatsappUrl, "_blank", "noopener,noreferrer");
                                            }}
                                        >
                                            <h6 className="button">Refer to Friend</h6>
                                        </button>



                                    </div>
                                </div>
                            </div>

                            {/* Specialization Course Box */}
                            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 p-3">
                                <div className="border card bg-white rounded-4 box-shadow hover-scale p-3 hover-purple">
                                    <h2 className="text-center mt-3">Specialization Course</h2>
                                    <p className="text-center ">Everything you need to land your dream job</p>
                                    <div className="mt-3">
                                        <div className="d-flex mt-1 align-items-center">
                                            👨‍💻 <p className="ms-1">Daily online class</p>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            ▶️<p className="ms-1">Daily class recording</p>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            🕖<p className="ms-1">24/7 Mentor support</p>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            💻<p className="ms-1">Premium Notes & Softwares</p>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            👩🏻‍💼<p className="ms-1">Placement trainings</p>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            💯<p className="ms-1">100% Placement assistance</p>
                                        </div>
                                    </div>
                                    {/* <div className="bg1 mt-3 ps-3">
                                    <div className="d-flex mb-2">
                                        <p className="m-0">They pay</p>
                                        <div className="border border-dark rounded-3 ms-2">-20%</div>
                                    </div>
                                    <div className="d-flex">
                                        <s>₹4,540.00</s>
                                        <p className="ms-1">
                                            <b>₹3,638.40</b>
                                        </p>
                                    </div>
                                </div> */}
                                   <div className="d-flex align-items-center text-success commission pt-2 ps-2 mt-2 rounded">
                                        🎁<p className="ms-1 sm-18 m-0">Your commission</p>
                                        <h5 className="ms-3 sm-16 m-0 mt-2">₹250</h5>
                                    </div>
                                    <div className="d-flex mt-4 mb-2">
                                        <CopyToClipboard onCopy={() => settoast(true)} text={`https://skillsuprise.com/referral=${refdata.referral_code}`}  >

                                            <button className="border rounded bg-white p-2 copyb">📋</button>

                                        </CopyToClipboard>

                                        <button
                                            className="refer-button border ms-2 w-100 text-center rounded pt-2 copyb"
                                            onClick={() => {
                                                const referralUrl = `https://skillsuprise.com/referral=${refdata.referral_code}`;
                                                const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(referralUrl)}`;
                                                window.open(whatsappUrl, "_blank", "noopener,noreferrer");
                                            }}
                                        >
                                            <h6 className="button">Refer to Friend</h6>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {/* Offline Course Box */}
                            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 p-3">
                                <div className="border card bg-white rounded-4 box-shadow hover-scale p-3 hover-purple">
                                    <h2 className="text-center mt-3">Offline Course</h2>
                                    <p className="text-center ">Everything you need to master skills with us</p>
                                    <div className="mt-3">
                                        <div className="d-flex align-items-center">
                                            👨‍💻 <p className="ms-1">Daily online class</p>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            ▶️<p className="ms-1">Daily class recording</p>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            🕖<p className="ms-1">24/7 Mentor support</p>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            💻<p className="ms-1">Premium Notes & Softwares</p>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            👩🏻‍💼<p className="ms-1">Placement trainings</p>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            💯<p className="ms-1">100% Placement assistance</p>
                                        </div>
                                    </div>
                                    {/* <div className="bg1 mt-3 ps-3">
                                    <div className="d-flex mb-2">
                                        <p className="m-0">They pay</p>
                                        <div className="border border-dark rounded-3 ms-2">-20%</div>
                                    </div>
                                    <div className="d-flex">
                                        <s>₹10,188.00</s>
                                        <p className="ms-1">
                                            <b>₹8,150.40</b>
                                        </p>
                                    </div>
                                </div> */}
                                  <div className="d-flex align-items-center text-success commission pt-2 ps-2 mt-2 rounded">
                                        🎁<p className="ms-1 sm-18 m-0">Your commission</p>
                                        <h5 className="ms-3 sm-16 m-0 mt-2">₹500</h5>
                                    </div>
                                    <div className="d-flex mt-4 mb-2">
                                        <CopyToClipboard onCopy={() => settoast(true)} text={`https://skillsuprise.com/referral=${refdata.referral_code}`}  >

                                            <button className="border rounded bg-white p-2 copyb">📋</button>

                                        </CopyToClipboard>





                                        <button
                                            className="refer-button border ms-2 w-100 text-center rounded pt-2 copyb"
                                            onClick={() => {
                                                const referralUrl = `https://skillsuprise.com/referral=${refdata.referral_code}`;
                                                const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(referralUrl)}`;
                                                window.open(whatsappUrl, "_blank", "noopener,noreferrer");
                                            }}
                                        >
                                            <h6 className="button">Refer to Friend</h6>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </> : <>

{/* <UnregisteredReferralPage/> */}

<p></p>
               
                </>}












            </>

        </Styled>



    )
}
export default ScratchCards
const Styled = styled.div`
.bg{
   background-color:#c5cde926}
.bg1{ 
   background-color:#fafbff}

 .bg2{ 
   background-color:#D6EAF8}
.text{ 
   color:#2f1c6a}
.refer{
  color:#673de6} 
.bg3{
   background-color:#673de6}  
.bd{
  border: 1px solid #673de6 !important;
}
.mt28{
   margin-top:-28px;}  

`
